module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGF01-2395882bccbfee8a2ee63db95d4ef033.png";